// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3kWdx","disabled":"FileBtn_disabled__30mZM","warn":"FileBtn_warn__1JQVW","fade":"FileBtn_fade__1Apmu"};